import { create } from "zustand";

type Status = "Pending" | "Approved" | "Rejected";

interface HookProps {
  filter: Status;
  setFilter: (filter: Status) => void;
}

export const useStatusFilter = create<HookProps>()((set) => ({
  filter: "Approved",
  setFilter: (filter) =>
    set(() => ({
      filter,
    })),
}));
